import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => {
  return {
    bodyModalList: { 
        backgroundColor: "#FFF"
    },
    iconCloseIcon: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: '20px',
      marginRight: '30px',
      marginTop: '30px',
      cursor: 'pointer'
    },
    contentTitle: {
      textAlign: 'center',
      font: `700 19px/25px "Montserrat"`,
      color: theme.custom.colors.primary,
      marginBottom: "50px"
    },
    listType: {
      display: 'flex',
      width: '70%',
      justifyContent: 'center',
      margin: '0 auto',
      marginBottom: "100px"
    },
    itemType: {
      boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
      borderRadius: 10,
      textAlign: 'center',
      cursor: 'pointer',
      padding: "20px",
      minWidth: "60%",
      '&:not(:last-child)': {
        marginRight: 64
      },
      '& img': {
        marginBottom: 27
      },
    },
    typeTitle: {
      font: theme.custom.font.headingMontserrat3,
      marginBottom: 15
    },
    typeDes: {
      font: 'normal normal 400 14px/18px Montserrat',
      marginBottom: 13,
      color: theme.custom.colors.midBlack,
      textAlign: "left"
    },
    itemType2: {
      boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
      borderRadius: 10,
      textAlign: 'center',
      padding: "20px",
      minWidth: "60%",
      cursor: 'pointer',
      '&:not(:last-child)': {
        marginRight: 64
      },
      '& img': {
        marginBottom: 27
      },
    },
      
    modalContainer: {
      textAlign: "center",
    },
    modalHeader: {
      marginBottom: 80,
      font: theme.custom.font.headingMontserrat1,
      fontSize: "15px",
      fontWeight: "bold",
      marginTop: "13px",
    },
    closingIcon: {
      display: "flex",
      justifyContent: "flex-end",
      cursor: "pointer",
      marginTop: -100,
      position: "absolute",
      right: 25,
    },
    buttonContainer: {
      height: 100,
      marginRight: 20,
    },
  };
});

export default useStyles;
